import React, { useEffect, useState, useRef } from "react";
import {
  FiFileText,
  FiFile,
  FiCalendar,
  FiCheckSquare,
  FiChevronDown,
  FiMapPin,
  FiClipboard,
  FiUsers,
  FiMessageSquare
} from "react-icons/fi";
import { AiFillBank } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import OverviewTab from "./OverviewTab";
import { useSelector } from "react-redux";
import accountApi from "../../api/accountApi";
import BankDetails from "../banks/BankDetails";
import GSTInfoTab from "./GSTInfoTab";
import TDSInfoTab from "./TDSInfoTab";
import CommunicationsTab from "./CommunicationsTab";
import DocumentsTab from "./DocumentsTab";
import MeetingsTab from "./MeetingsTab";
import TasksTab from "./TasksTab";
import WorkflowsTab from "./WorkflowsTab";
import LocationsTab from "./LocationsTab";
import Loading from "../../components/Loading";
import { ArrowLeft, Menu } from "lucide-react";
import Mgt1RegisterViewer from "./RegistrationForm/Mgt1ResisteredViewer";
import Mgt2RegisterViewer from "./RegistrationForm/Mgt2RegisteredViewer";
import EmailSchedules from "../email/EmailSchedules";
import ComplianceTab from "./ComplianceTab";
import { FiShield } from "react-icons/fi";
import { BarChart2 } from "lucide-react";
import AccountReport from "./AccountReport";
import Sh3Viewer from "./RegistrationForm/Sh3Viewer";
import Sh6Viewer from "./RegistrationForm/Sh6Viewer";
import Sh10Viewer from "./RegistrationForm/Sh10Viewer";
import Mbp2Viewer from "./RegistrationForm/Mbp2viewer";
import Mbp3Viewer from "./RegistrationForm/Mbp3Viewer";
import Ch7Viewer from "./RegistrationForm/Ch7Viewer";
import Mbp4Viewer from "./RegistrationForm/Mbp4Viewer";
import Sh2Viewer from "./RegistrationForm/Sh2Viewer";
import DirectorAndKmpViewer from "./RegistrationForm/DirectorAndKmpViewer";

const AccountDetails = () => {
  const [moreOpen, setMoreOpen] = useState(false);
  const [moreOpen1, setMoreOpen1] = useState(false);
  const [moreDirection, setMoreDirection] = useState("right");
  const moreRef = useRef();
  const moreRef1 = useRef();

  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("report");
  const token = useSelector((state) => state.auth.access_token);
  const { accountsId } = useParams();
  const navigate =useNavigate()


  const fetchAccount = async () => {
      try {
        const data = await accountApi.getAccount(accountsId, token);
        setAccount(data.data);
      } catch (error) {
        console.error("Error fetching account:", error);
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => { 
    if (token) fetchAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountsId, token]);

  const tabs = [
    { id: "report", label: "Report", icon: <BarChart2 color="blue"/> },
    { id: "details", label: "Account Details", icon: <FiFileText color="blue"/> },
    { id: "bank-details", label: "Bank Details", icon: <AiFillBank color="blue"/> },
    { id: "gst-info", label: "GST", icon: <FiFile color="blue"/> },
    { id: "tds-info", label: "TDS", icon: <FiCalendar color="blue"/> },
    { id: "locations", label: "Locations", icon: <FiMapPin color="blue"/> },
    { id: "workflows", label: "Workflows", icon: <FiClipboard color="blue"/> },
    { id: "tasks", label: "Tasks", icon: <FiCheckSquare color="blue"/> },
    { id: "meetings", label: "Meetings", icon: <FiUsers color="blue"/> },
    { id: "documents", label: "Documents", icon: <FiFileText color="blue"/> },
    // { id: "mgt1", label: "MGT-1", icon: <FiFileText color="blue"/> },
    // { id: "mgt2", label: "MGT-2", icon: <FiFileText color="blue"/> },
    // { id: "sh3", label: "SH-3", icon: <FiFileText color="blue"/> },
    // { id: "sh6", label: "SH-6", icon: <FiFileText color="blue"/> },
    // { id: "sh10", label: "SH-10", icon: <FiFileText color="blue"/> },
    { id: "communications", label: "Communications", icon: <FiMessageSquare color="blue"/> }
  ];
  const tabs1 = [
    { id: "mgt1", label: "MGT-1", icon: <FiFileText color="blue"/> },
    { id: "mgt2", label: "MGT-2", icon: <FiFileText color="blue"/> },
    { id: "compliance", label: "Compliance", icon: <FiShield color="blue"/> },
    { id: "sh3", label: "SH-3", icon: <FiFileText color="blue"/> },
   
    { id: "sh6", label: "SH-6", icon: <FiFileText color="blue"/> },
    { id: "sh10", label: "SH-10", icon: <FiFileText color="blue"/> },
  ];

  const renderTab = () => {
    switch (activeTab) {
      case "details": return <OverviewTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "bank-details": return <BankDetails selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "gst-info": return <GSTInfoTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "tds-info": return <TDSInfoTab selectedClientData={account}/>;
      case "locations": return <LocationsTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "workflows": return <WorkflowsTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "tasks": return <TasksTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "meetings": return <MeetingsTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "mgt1": return <Mgt1RegisterViewer selectedClientData={account}/>;
      case "mgt2": return <Mgt2RegisterViewer selectedClientData={account}/>;
      case "dir&kmp": return <DirectorAndKmpViewer selectedClientData={account}/>;
      case "sh2": return <Sh2Viewer selectedClientData={account}/>;

      case "sh3": return <Sh3Viewer selectedClientData={account}/>;
      case "sh6": return <Sh6Viewer selectedClientData={account}/>;
      case "sh10": return <Sh10Viewer selectedClientData={account}/>;
       case "chg7": return <Ch7Viewer selectedClientData={account}/>;
      case "mbp2": return <Mbp2Viewer selectedClientData={account}/>;
      case "mbp3": return <Mbp3Viewer selectedClientData={account}/>;
      case "mbp4": return <Mbp4Viewer selectedClientData={account}/>;
     
      case "documents": return <DocumentsTab selectedClientData={account}/>;
      case "email": return <EmailSchedules accountId={account.id}/>;
      case "compliance": return <ComplianceTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "communications": return <CommunicationsTab selectedClientData={account} onRefreshAccounts={fetchAccount}/>;
      case "report": return <AccountReport accountId={accountsId}/>;
      default: return null;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreRef.current && !moreRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreRef1.current && !moreRef1.current.contains(event.target)) {
        setMoreOpen1(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!moreOpen) return;
    const rect = moreRef.current.getBoundingClientRect();
    if (window.innerWidth - rect.right < 200) setMoreDirection("left");
    else setMoreDirection("right");
  }, [moreOpen]);

  if (loading) return <Loading/>;

  return (
    <div className="flex flex-col h-screen bg-gray-100">
         <div className="flex items-center space-x-3 min-w-0 bg-white px-1">
                    <button
                        onClick={() => navigate(-1)}
                        className="text-gray-500 hover:text-gray-700 flex-shrink-0"
                    >
                        <ArrowLeft className="h-5 w-5" />
                    </button>
                    <h1 className="text-lg sm:text-xl font-semibold text-gray-900 truncate">
                        {account?.accountName}
                    </h1>
                </div>

              <div className="sticky top-0 bg-white px-2 py-1 border-b overflow-visible">
                <div className="flex items-center overflow-visible">
                  <div className="flex items-center space-x-1 overflow-x-auto">
                    {tabs.slice(0, 9).map(tab => (
                      <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-2 px-2 py-1 rounded-md text-sm font-medium whitespace-nowrap transition ${
                          activeTab === tab.id ? "bg-indigo-50 text-indigo-600" : "text-gray-600 hover:bg-gray-100"
                        }`}
                      >
                        {tab.icon}<span className="hidden sm:inline">{tab.label}</span>
                      </button>
                    ))}
                  </div>

                    <div ref={moreRef1} className="relative ml-2">
                      <div className="flex flex-row items-center">
                        <button onClick={() => setMoreOpen1(!moreOpen1)}
                          className="flex items-center gap-1 px-2 py-1.5 rounded-md text-sm font-medium text-gray-600 hover:bg-gray-100"
                        >
                         <Menu size={14} color="blue"/> Register Form
                        </button>
                      </div>

                      {moreOpen1 && (
                        <div className={`absolute top-full mt-1 w-48 bg-white border rounded-md shadow-lg z-50 ${
                          moreDirection === "left" ? "right-0" : "left-0"
                        }`}>
                          {tabs1.map(tab => (
                            <button key={tab.id} onClick={() => { setActiveTab(tab.id); setMoreOpen1(false); }}
                              className={`w-full flex items-center gap-2 px-1 py-1 text-sm ${
                                activeTab === tab.id ? "bg-indigo-50 text-indigo-600" : "text-gray-600 hover:bg-gray-100"
                              }`}
                            >
                              {tab.icon}{tab.label}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                  {tabs.length > 9 && (
                    <div ref={moreRef} className="relative ml-2">
                      <div className="flex flex-row items-center">
                        <button onClick={() => setMoreOpen(!moreOpen)}
                          className="flex items-center gap-1 px-2 py-1.5 rounded-md text-sm font-medium text-gray-600 hover:bg-gray-100"
                        >
                          More <FiChevronDown className="text-xs"/>
                        </button>
                      </div>

                      {moreOpen && (
                        <div className={`absolute top-full mt-1 w-48 bg-white border rounded-md shadow-lg z-50 ${
                          moreDirection === "left" ? "right-0" : "left-0"
                        }`}>
                          {tabs.slice(9).map(tab => (
                            <button key={tab.id} onClick={() => { setActiveTab(tab.id); setMoreOpen(false); }}
                              className={`w-full flex items-center gap-2 px-1 py-1 text-sm ${
                                activeTab === tab.id ? "bg-indigo-50 text-indigo-600" : "text-gray-600 hover:bg-gray-100"
                              }`}
                            >
                              {tab.icon}{tab.label}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>


      <main className="mt-2 pb-10">
        {renderTab()}
      </main>
    </div>
  );
};

export default AccountDetails;
